<div class="flex flex-col">
  <mat-form-field class="radio-box-input flex-0-0-50" floatPlaceholder="always" floatLabel="always"
                  appearance="outline">
    <input matInput placeholder="Input" style="display: none"
           particleAnalytics
           analyticsCategory="radio-box-input-editor"
           analyticsAction="radio-box-input">
    <mat-radio-group
      class="dac6-case-hashtag-radio-group"
      [(ngModel)]="caseType"
      (ngModelChange)="onCaseTypeChange($event)"
    >
      <mat-radio-button class="dac6-case-hashtag-radio-button flex flex-col" [value]="'new'">
        Assign to new DAC6 Case
      </mat-radio-button>
      <mat-radio-button class="dac6-case-hashtag-radio-button flex flex-col" [value]="'existing'">
        Assign to existing DAC6 Case
      </mat-radio-button>
    </mat-radio-group>

  </mat-form-field>

  <div *ngIf="caseType=== 'existing'" class="flex flex-col full-grow-no-shrink-no-basis">
    <div class="content pos-relative m-t-10">
      <div class="keno-grid-container">
        <particle-virtual-grid [sourceKey]="sourceType"
                               [invalidateSubject]="invalidateSubject"
                               (selectionChanged)="onSelectionChanged($event)"
                               sortFieldKey="CaseId"
                               sortDirection="desc"
                               prefixSortFieldKey="FieldValues."
                               [sortEnabled]="true"
                               serviceName="CaseDynamicItemService"
                               api="DAC6Api"
        >
        </particle-virtual-grid>
      </div>
    </div>
  </div>
</div>

